<template>
  <v-row class="mt-4">
    <v-col col="12" sm="6" md="6" lg="6">
      <v-select
        :items="items"
        label="Search by month"
        item-value="id"
        item-text="name"
        v-model="month"
        dense
      ></v-select>
    </v-col>
    <v-col col="12" sm="6" md="6" lg="6">
      <v-select
        :items="Years"
        label="Search by Year"
        item-value="id"
        item-text="name"
        v-model="year"
        dense
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  name: "AccountMonthllySearchList",
  data() {
    return {
      month: -1,
      year: -1,
      Years: [],
      items: [
        {
          id: -1,
          name: "All",
        },
        {
          id: "January",
          name: "January",
        },
        {
          id: "February",
          name: "February",
        },
        {
          id: "March",
          name: "March",
        },
        {
          id: "April",
          name: "April",
        },
        {
          id: "May",
          name: "May",
        },
        {
          id: "June",
          name: "June",
        },
        {
          id: "July",
          name: "July",
        },
        {
          id: "August",
          name: "August",
        },
        {
          id: "September",
          name: "September",
        },
        {
          id: "Octobar",
          name: "Octobar",
        },
        {
          id: "November",
          name: "November",
        },
        {
          id: "December",
          name: "December",
        },
      ],
    };
  },
  methods: {
    getYears() {
      let current_year = moment().format("YYYY");
      this.Years.push({
        id: -1,
        name: "All",
      });
      for (let index = parseInt(current_year); index > 1985; index--) {
        this.Years.push({
          id: index,
          name: index,
        });
      }
    },
  },
  watch: {
    month() {
      this.$emit("change", this.month);
    },
    year() {
      this.$emit("changeYear", this.year);
    },
  },
  mounted() {
    this.getYears();
  },
};
</script>
